import React from "react";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import { alertSuccess } from "../../utils/alerts";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { formatServerErrors } from "Utils/serverFormats";
import { displayFormattedDate } from "Utils/dateFormats";
import ButtonBack from "Components/buttonBack/ButtonBack";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";
import Loader from "Components/loader/Loader";
import Tabs from "Components/tabs/Tabs";
import Password from "./settings/Password";
import Limits from "./settings/Limits";
import ManagerDeliverySettings from "./settings/DeliverySettings";
import cx from "classnames";
import s from "./showManager.scss";
import t from "Utils/translation";
import _ from "lodash";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

const formInitialState = {
  max_domains: 5,
  max_email_accounts: 10,
  max_email_accounts_archive: 10,
  max_email_accounts_25gb: 10,
  max_email_accounts_50gb: 0,
  max_email_accounts_100gb: 0,
  max_delivery_domains: 1,
  max_delivery_accounts: 1,
  firstname: "",
  lastname: "",
  company: "",
  password: "",
  password_confirmation: "",
  email_address: "",
  domain_codes: [],
  customer_code: undefined,
};

class ManagerShowScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfo: props.isMediaMobile ? false : true,
      isLoadingDeliveryResources: true,
      deliveryResourcesWithoutManager: {},
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getManager();
    this.props.getAllDomainsWithoutManagers({
      customer_code: this.props.match.params.customerCode,
    });

    this.getDeliveryResourcesWithoutManagers();
  }

  getDeliveryResourcesWithoutManagers = async () => {
    this.setState({ isLoadingDeliveryResources: true });

    const api = new QboxmailApi({ useCookie: true });
    let res;
    try {
      res = await api.getDeliveryResourcesWithoutManagers({
        customer_code: this.props.match.params.customerCode,
      });
    } catch (err) {
      res = null;
    }

    this.setState({ deliveryResourcesWithoutManager: res, isLoadingDeliveryResources: false });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const managerLoaded = this.props.isManagerLoading && !nextProps.isManagerLoading;
    const managerRefreshed = this.props.isManagerRefreshing && !nextProps.isManagerRefreshing;
    if (managerLoaded || managerRefreshed) {
      const { manager } = nextProps;
      this.props.setInitialValues({
        max_domains: manager.max_domains,
        max_email_accounts: manager.max_email_accounts,
        max_email_accounts_archive: manager.max_email_accounts_archive,
        max_email_accounts_25gb: manager.max_email_accounts_25gb,
        max_email_accounts_50gb: manager.max_email_accounts_50gb,
        max_email_accounts_100gb: manager.max_email_accounts_100gb,
        max_delivery_accounts: manager.max_delivery_accounts,
        max_delivery_domains: manager.max_delivery_domains,
        domain_codes: manager.domain_codes,
        customer_code: manager.customer_code,
      });
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true,
      });
    }
  }

  submitForm = (values, fieldsToSend = []) => {
    const {
      refreshManager,
      unsetFormLoading,
      setFormErrors,
      match: {
        params: { managerCode },
      },
      setFormLoading,
    } = this.props;
    setFormLoading();
    const dataToSend = {};
    fieldsToSend.forEach((f) => (dataToSend[f] = values[f]));

    const api = new QboxmailApi({ useCookie: true });
    api
      .editManager(managerCode, dataToSend)
      .then(() => {
        refreshManager();
        unsetFormLoading();
        setFormErrors({});
        alertSuccess(t("alert.managerUpdatedSuccess"));
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          console.log("eerrrr", errors);
          setFormErrors(errors);
          unsetFormLoading();
        });
      });
  };

  goBack = () => {
    const { location } = this.props;
    const query = _.get(location, "state.prevPagination", "");
    this.props.history.push("/managers" + query);
  };

  toggleInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };

  render() {
    const { isManagerLoading, manager, formErrors } = this.props;

    const { showInfo } = this.state;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    const loggedUser = this.context.getLoggedUser();

    if (isManagerLoading) {
      return <Loader />;
    }

    return (
      <div className={s.showManager}>
        <div className={s.navigation}>
          <ButtonBack onClick={this.goBack} />
          <div className={s.viewSectionLabel}>{t("section.view.manager")}</div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">{`${manager.firstname} ${manager.lastname}`}</div>
            {isMediaMobile() && (
              <div className={cx(s.showInfo, "internalLink")} onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>

          {showInfo && (
            <div className={s.subtitle}>
              <DetailStatus status={manager.status} />
              <div className="sectionDesc">{manager.email_address}</div>
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={manager.code} inLine />
              <DetailInfo label={t("detailInfo.label.company")} info={manager.company ? manager.company : "–"} inLine />
              <DetailInfo
                label={t("detailInfo.label.created")}
                info={displayFormattedDate(manager.created_at)}
                inLine
              />
            </div>
          )}
        </div>
        <Tabs
          className={s.settings}
          {...this.props}
          tabs={{
            [t("tab.security")]: <Password submitForm={this.submitForm} {...this.props} loggedUser={loggedUser} />,
            [t("tab.emailHostingLimits")]: (
              <Limits submitForm={this.submitForm} {...this.props} loggedUser={loggedUser} />
            ),

            [t("tab.deliveryLimits")]: (
              <ManagerDeliverySettings
                submitForm={this.submitForm}
                {...this.props}
                loggedUser={loggedUser}
                getDeliveryResourcesWithoutManagers={this.getDeliveryResourcesWithoutManagers}
                deliveryResourcesWithoutManager={this.state.deliveryResourcesWithoutManager}
                isLoadingDeliveryResources={this.state.isLoadingDeliveryResources}
              />
            ),
          }}
        />
      </div>
    );
  }
}

//ManagerShowScreen.propTypes = propTypes;
ManagerShowScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  manager: resActions.getData("manager.data.0", state),
  domainsWithoutManagers: resActions.getData("domainsNoManagers.data", state),
  areDomainsWithoutManagersLoading: resActions.isResourceLoading("domainsNoManagers", state),
  isManagerLoading: resActions.isResourceLoading("manager", state),
  isManagerRefreshing: resActions.isResourceRefreshing("manager", state),
});

const mapDispatchToProps = (dispatch, props) => {
  const managerCode = props.match.params.managerCode;

  return {
    getAllDomainsWithoutManagers: (params) => {
      dispatch(resActions.callApi("getAllDomainsWithoutManagers", "domainsNoManagers", params));
    },
    refreshManager: () => dispatch(resActions.callApi("refreshManager", "manager", managerCode)),
    refreshManagers: (queryParams) => dispatch(resActions.callApi("refreshManagers", "managers", queryParams)),
    getManager: () => dispatch(resActions.callApi("getManager", "manager", managerCode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(ManagerShowScreen, formInitialState));
